import { ValueOfKey } from '../../../../utils-types';

// tableMode controls column visibility independently from solutionType filter
// ALL — show all columns + Solution column
export const UNREAD_SCANS_TABLE_MODE = {
  ALL: 'ALL',
  NUTRITION: 'NUTRITION',
  SCAN_IQ: 'SCAN_IQ',
} as const;

export type UnreadScansTableMode = ValueOfKey<typeof UNREAD_SCANS_TABLE_MODE>;

export const UNREAD_SCANS_COLUMN = {
  NAME: 'NAME',
  SOLUTION: 'SOLUTION',
  COACH: 'COACH',
  ACTIVE_SINCE: 'ACTIVE_SINCE',
  DATE_OF_UPDATE: 'DATE_OF_UPDATE',
} as const;

export type UnreadScansColumn = ValueOfKey<typeof UNREAD_SCANS_COLUMN>;
export type ShowColumnsConfig = Record<UnreadScansColumn, boolean>;

export const COLUMN_WIDTHS: Record<UnreadScansColumn, string> = {
  NAME: '1.25fr',
  SOLUTION: '1fr',
  COACH: '1fr',
  ACTIVE_SINCE: '1fr',
  DATE_OF_UPDATE: 'auto',
};
